import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AccountSetupErrorProps {
  onLogout: () => void;
}

/**
 * Affiché quand un franchisé authentifié n'a aucun magasin même après la
 * tentative de réparation automatique (repair-account). Remplace l'ancien
 * loader infini « Chargement du magasin... ».
 */
export const AccountSetupError = ({ onLogout }: AccountSetupErrorProps) => (
  <div className="min-h-screen flex items-center justify-center bg-background p-4">
    <div className="max-w-md w-full text-center space-y-6">
      <div className="mx-auto w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
        <AlertTriangle className="w-7 h-7 text-destructive" />
      </div>
      <div className="space-y-2">
        <h1 className="text-xl font-semibold text-foreground">
          Configuration du compte incomplète
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Votre compte a bien été créé, mais son initialisation ne s'est pas
          terminée correctement et n'a pas pu être réparée automatiquement.
          Notre équipe a été notifiée.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <Button onClick={() => window.location.reload()}>Réessayer</Button>
        <Button variant="outline" onClick={onLogout}>
          Se déconnecter
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Si le problème persiste, écrivez-nous à{" "}
        <a href="mailto:contact@equiply.fr" className="text-primary hover:underline">
          contact@equiply.fr
        </a>
        .
      </p>
    </div>
  </div>
);
